// src/resources/bookings/components/BookingShow.tsx
import {
  Show,
  TabbedShowLayout,
  Tab,
  TextField,
  DateField,
  NumberField,
  FunctionField,
} from "react-admin";
import { Box, Typography } from "@mui/material";
import { BookingStatusChip } from "./BookingStatusChip";
import { BookingActions } from "./BookingActions";

export const BookingShow = () => (
  <Show>
    <TabbedShowLayout>
      <Tab label="Booking Details">
        <TextField source="id" label="Booking ID" />
        <TextField source="providerOrderId" label="Provider Order ID" />
        <BookingStatusChip />
        <DateField source="checkIn" label="Check-in Date" />
        <DateField source="checkOut" label="Check-out Date" />
        <NumberField source="guests" label="Number of Guests" />
        <NumberField source="numberOfRooms" label="Rooms" />
        <TextField source="roomType" label="Room Type" />
      </Tab>

      <Tab label="Property Information">
        <FunctionField
          label="Property Name"
          render={(record) => record.property?.name || "N/A"}
        />
        <NumberField source="propertyHid" label="Property HID" />
        <TextField source="property.address" label="Address" />
        <TextField source="property.regionName" label="Region" />
        <TextField source="property.regionType" label="Region Type" />
      </Tab>

      <Tab label="Customer Information">
        <FunctionField
          label="Customer Name"
          render={(record) =>
            record.user?.name || record.user?.username || "N/A"
          }
        />
        <TextField source="user.email" label="Email" />
        <TextField source="user.phoneNumber" label="Phone" />
        <TextField source="user.residency" label="Residency" />
      </Tab>

      <Tab label="Financial Details">
        <NumberField source="amountB2B2C" label="Customer Amount" />
        <NumberField source="ourProfit" label="Our Profit" />
        <NumberField source="amountToPayProvider" label="Provider Payout" />
        <TextField source="currency" label="Currency" />
        <TextField source="paymentMode" label="Payment Mode" />
        <TextField
          source="stripePaymentIntentId"
          label="Stripe Payment Intent"
        />
      </Tab>

      <Tab label="System Information">
        <DateField source="createdAt" label="Created At" showTime />
        <DateField source="updatedAt" label="Updated At" showTime />
        <TextField source="provider" label="Provider" />
        <TextField source="providerBookingId" label="Provider Booking ID" />
      </Tab>

      <Tab label="Actions">
        <Box sx={{ p: 3 }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <FunctionField render={() => "📝"} />
            Booking Actions
          </Typography>
          <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
            Manage this booking with the available actions below. Each action is
            contextual based on the current booking status.
          </Typography>
          <BookingActions />
        </Box>
      </Tab>
    </TabbedShowLayout>
  </Show>
);
